angular.module('cfn').directive('cfnBookingSeed', cfnBookingSeed);

cfnBookingSeed.$inject = [
    '$q',
    '$rootScope',
    'bookingService',
    'bookingRules',
    'companyFinanceService',
    'search.service',
    'userSettingsService',
    'seedSuggestionService',
    'i18nFilter'
];

function cfnBookingSeed(
    $q,
    $rootScope,
    bookingService,
    bookingRules,
    companyFinanceService,
    searchService,
    userSettingsService,
    seedSuggestionService,
    i18nFilter
) {
    return {
        restrict: 'E',
        templateUrl: require('./seedTable.html'),
        controller: [
            '$scope',
            function ($scope) {
                $scope.isEngland = userSettingsService.getIsoCountryEnum() === 'GBR';
                const objectType = $scope.ele.name,
                    type = 'supply',
                    list = objectType + 'List';

                $scope.currentSelectedSeed = undefined;

                // Load data from common booking state object into local format
                bookingRules.elements.seed.onLoad = function (result) {
                    // result.supplies[supplyType=="Seed" -> $scope.details.seedList
                    $scope.details.seedList = result.supplies.filter(function (supply) {
                        return supply.supplyType === 'Seed';
                    });
                    $scope.details.anteil_seedList = result.supplyProportions.filter(
                        function (supply) {
                            return supply.supplyType === 'Seed';
                        }
                    );

                    if ($scope.details.seedList.length > 0 && result.supplies[0].sowingTypeOptions ) {
                        $scope.details.sowingTypeRestrictedOptions = result.supplies[0].sowingTypeOptions.filter(
                            function (sowingTypeOption) {
                                return sowingTypeOption !== 'CATCH_CROP' && sowingTypeOption !== 'UNDERSOWN_CROP'; //Don't show the catch crop option for the time being.
                            }
                        );
                    }

                    $scope.seedChanged($scope.details.seedList[0]);

                    if (searchIndex) {
                        searchIndex.clearExcludedItems();
                    }
                    excludeAllAddedFields();
                };

                // Transform details-data (fieldList, seedList, ...) to BE-Data (assets, products,...)
                bookingRules.elements.seed.onSave = function (result) {
                    if ($scope.details.seedList) {
                        if (!angular.isArray(result.supplies)) {
                            result.supplies = [];
                        }
                        $scope.details.seedList.forEach(function (seed) {
                            seed.supplyType = 'Seed';
                            result.supplies.push(seed);
                        });
                    }
                    if ($scope.details.anteil_seedList) {
                        if (!angular.isArray(result.supplyProportions)) {
                            result.supplyProportions = [];
                        }
                        $scope.details.anteil_seedList.forEach(function (supplyProportion) {
                            result.supplyProportions.push(supplyProportion);
                        });
                    }
                };

                bookingRules.elements.seed.onInsert = function (
                    operationSupplyDetailDTO
                ) {
                    const newItem = operationSupplyDetailDTO;
                    // Apply defaults from core data
                    newItem.weight1000 = operationSupplyDetailDTO.supply.weight1000;
                    newItem.germinationCap =
                        operationSupplyDetailDTO.supply.germinationCap;
                    newItem.grainsPerUnit = operationSupplyDetailDTO.supply.seedsPerUnit;
                    newItem.sowingType = operationSupplyDetailDTO.supply.sowingType;
                    newItem.unit = operationSupplyDetailDTO.supply.seedUnit;
                    newItem.originalUnit = newItem.unit;
                    newItem.costsGrossPrice = operationSupplyDetailDTO.supply.grossPrice;
                    newItem.seedStrength = operationSupplyDetailDTO.supply.seedStrenght;

                    // set id in item for easy unique-check.
                    newItem.feid = operationSupplyDetailDTO.supply.id;
                    bookingService.addToList($scope, newItem, 'seedList');

                    $scope.details.sowingTypeRestrictedOptions = _.filter(
                        operationSupplyDetailDTO.supply.sowingTypeOptions,
                        function (sowingType) {
                            return sowingType !== 'CATCH_CROP'; //Don't show the catch crop option for the time being.
                        }
                    );

                    // notify supply to take culture from seed
                    $scope.seedChanged(newItem);

                    resetAmountPerArea();
                    usePlanningValuesOrBaseDataValuesForSeedStrengthCalculation();
                    excludeAllAddedFields();
                    // applySeedSuggestionValues();
                };

                function excludeAllAddedFields() {
                    _.each($scope.details.seedList, function (item) {
                        searchIndex.excludeFromIndex(item.supply.id);
                    });
                }

                $scope.remove = function (item) {
                    searchIndex.undoExcludeFromIndex(item.supply.id);
                    $scope.controller.removeFromList(objectType, type, list, item);

                    // notify supply to remove the given culture from indications
                    $scope.seedChanged(null);
                };


                $scope.seedChanged= function (sysSeed){
                    // broadcast if selected seed is changed
                    $rootScope.$broadcast('bookingmask-seed-changed', sysSeed);
                };

                // Init
                if ($scope.details) {
                    $scope.details.anteil_seedList = [];
                }

                $scope.currencySign = companyFinanceService.getCurrencySign();

                function resetAmountPerArea() {
                    if ($scope.details.seedList) {
                        angular.forEach($scope.details.seedList, function (item) {
                            // for each Seed...
                            $scope.details.anteil_seedList.forEach(function (anteilItem) {
                                anteilItem.specialDouble1 = null;
                            });
                        });
                    }
                }
                
                /**
                 * If the choosen seed comes from a planning, the properties of the planning like area and amount per area
                 * will be taken over from the planning. After that the booking service recalculate the depending values.
                 */
                function usePlanningValuesOrBaseDataValuesForSeedStrengthCalculation(useOnlyPlanningValues) {
                    if ($scope.details.seedList) {
                        angular.forEach($scope.details.seedList, function (item) {
                            // for each Seed...
                            $scope.details.anteil_seedList.forEach(function (anteilItem) {
                                /**
                                 * If the choosen seed comes from a planning, the properties of the planning like area and amount per area
                                 * will be taken over from the planning. After that the booking service recalculate the depending values.
                                 */
                                let usePlanning;
                                if(useOnlyPlanningValues) {
                                  usePlanning = useOnlyPlanningValues;
                                } else {
                                  usePlanning = ($scope.currentSelectedSeed && $scope.currentSelectedSeed.field2SeedSuggestionDetails && $scope.currentSelectedSeed.field2SeedSuggestionDetails[anteilItem.assetId]);
                                }
                                if(usePlanning) {
                                    if($scope.currentSelectedSeed &&
                                        $scope.currentSelectedSeed.field2SeedSuggestionDetails &&
                                        $scope.currentSelectedSeed.field2SeedSuggestionDetails[anteilItem.assetId]) {
                                        applySeedSuggestionValues($scope.currentSelectedSeed,anteilItem);   
                                        $rootScope.alertController.addTemporaryAlert(i18nFilter('fe.booking.seed.fromPlanning.message',
                                                'Die Anbaufläche und Aussaatmenge wurden aus der Planung übernommen.'), 'success');
                                    }
                                    bookingService.calculation($scope, 'area', anteilItem, item);
                                } else {
                                  // ...calc all Anteil-Fields
                                  if (!anteilItem.specialDouble1) {
                                     if (item.unit !== 'QUANTITY_UNIT') {
                                          anteilItem.specialDouble1 = item.seedStrength;
                                      }
                                  }
                                  bookingService.calculation($scope, 'specialDouble1', anteilItem, item);
                                }
                            });
                        });
                    }
                    bookingService.summation($scope, 'anteil_seedList');
                }

                function recalcAnteil() {
                    if ($scope.details.seedList) {
                        angular.forEach($scope.details.seedList, function (item) {
                            // for each Seed...
                            $scope.details.anteil_seedList.forEach(function (anteilItem) {
                              // ...calc all Anteil-Fields
                              if (!anteilItem.specialDouble1) {
                                 if (item.unit !== 'QUANTITY_UNIT') {
                                      anteilItem.specialDouble1 = item.seedStrength;
                                  }
                              }
                              bookingService.calculation($scope, 'specialDouble1', anteilItem, item);
                            });
                        });
                    }
                    bookingService.summation($scope, 'anteil_seedList');
                }

                function applySeedSuggestionValues(selectedSeedItem,anteilItem) {
                    anteilItem.amountPerArea = $scope.currentSelectedSeed.field2SeedSuggestionDetails[anteilItem.assetId].seedStrength;
                    anteilItem.area = $scope.currentSelectedSeed.field2SeedSuggestionDetails[anteilItem.assetId].plannedArea;
                }

                // new Item?
                $scope.$watchCollection('details.seedList', function (newValue, oldValue) {
                    if (newValue !== oldValue && newValue) {
                        recalcAnteil();
                    }
                });

                // new Item?
                $scope.$watchCollection('details.anteil_seedList', function (newValue, oldValue) {
                    if (newValue !== oldValue && newValue) {
                        recalcAnteil();
                    }
                });

                // new or deleted Field? Insert/Delete in List
                $scope.$watchCollection('details.fieldList', function (newVal, oldVal) {
                    if (oldVal !== newVal && newVal) {
                        if (!$scope.details.anteil_seedList) {
                            $scope.details.anteil_seedList = [];
                        }

                        bookingService.mergeFieldList($scope, 'anteil_seedList',
                            function (newItem) {
                                newItem.supplyType = 'Seed';
                        });
                        usePlanningValuesOrBaseDataValuesForSeedStrengthCalculation(true);
                    }
                });

                // Anteil input-Field changed?
                $scope.changeAnteilField = function (fieldName, item) {
                    bookingService.calculation($scope, fieldName, item, $scope.details.seedList[0]);
                    bookingService.summation($scope, 'anteil_seedList');
                };

                $scope.changeTotalAmount = function() {
                    $scope.details.anteil_seedList.forEach(function (anteilItem) {
                        anteilItem.amount = (anteilItem.area / $scope.details.anteil_seedList_area_sum) * $scope.details.anteil_seedList_amount_sum;
                        bookingService.calculation(
                            $scope,
                            'amount',
                            anteilItem,
                            $scope.details.product[0]
                        );
                    });
                    bookingService.summation($scope, 'anteil_seedList');
                };

                // input-Field changed? -> recalc all Anteil-Fields
                $scope.changeField = function (fieldName, item) {
                    $scope.details.anteil_seedList.forEach(function (anteilItem) {
                        bookingService.calculation($scope, fieldName, anteilItem, item);
                    });

                    bookingService.summation($scope, 'anteil_seedList');
                };

                //search
                let searchIndex = searchService(objectType, {
                    initOnFirstSearch: true
                }).buildIndex({
                    fullText: function (item) {
                        return [
                            item.number,
                            item.name,
                            item.sysSeed_sysCulture_abbrFruit,
                            enums.SortCategoryEnum[item.sysSeed_sysCulture_category],
                            item.sysSeed_sysCulture_name
                        ];
                    },
                    handleResults: function (data) {
                        data.map(function (elem) {
                            elem._objectType = objectType; //this is required later on but legacy code...
                        });
                        return data;
                    }
                });

                // deprecated
                // $scope.search = searchIndex.fullTextSearch;


                /**
                 * search method for seed selection / search component
                 * @param item
                 * @returns {Promise<void>}
                 */
                $scope.search = async (item) => {
                    let _fieldIds = [];

                    // in case we have a new Booking TEMPLATE, there is no fieldLiest!
                    if ($scope.details && $scope.details.fieldList){
                        $scope.details.fieldList.forEach((field) => {
                            _fieldIds.push(field.asset.id);
                        });
                    }

                    let _years = [];
                    _years.push(getYear());
                    _years.push(getYear() + 1);

                    const _validLicense = app.credentials.licensedProducts.indexOf('PLAN') >= 0;

                    const _seedSuggestions = await seedSuggestionService.getSeedSuggestions(
                        item,
                        _fieldIds,
                        _years,
                        _validLicense);

                    const _seeds = await seedSuggestionService.getSeeds(item);

                    // filter out duplicates
                    _seedSuggestions.results.forEach((suggestion) => {
                        for (let x = 0; x < _seeds.results.length; x++) {
                            if (suggestion.id === _seeds.results[x].id) {
                                _seeds.results.splice(x, 1);
                            }
                        }
                    });

                    _seedSuggestions.results = _seedSuggestions.results.concat(_seeds.results);

                    // console.log('SEED SUGGESTIONS: ', _seedSuggestions.results);

                    _seedSuggestions.totalElements += _seeds.totalElements;
                    _seedSuggestions.last = _seeds.last;
                    _seedSuggestions.searchString = item;

                    // in memory search function
                    if (_seedSuggestions.searchString && _seedSuggestions.searchString !== '') {
                        let matchedData = [];

                        _seedSuggestions.results.forEach((suggestion) => {
                            if (suggestion.sysSeed_sysCulture_name.toLowerCase().match(_seedSuggestions.searchString.toLowerCase()) ||
                                suggestion.name.toLowerCase().match(_seedSuggestions.searchString.toLowerCase()) ||
                                suggestion.sysSeed_sysCulture_abbrFruit.toLowerCase().match(_seedSuggestions.searchString.toLowerCase()) ||
                                suggestion.id.toLowerCase().match(_seedSuggestions.searchString.toLowerCase()) ||
                                (suggestion.year && suggestion.year.toString().toLowerCase().match(_seedSuggestions.searchString.toLowerCase()))) {

                                matchedData.push(suggestion);
                            }
                        });
                        // reset results to matched data or to show that nothing was found
                        _seedSuggestions.results = matchedData;
                        _seedSuggestions.totalElements = matchedData.length;
                    }

                    return $q((resolve, reject) => {
                        resolve(_seedSuggestions);
                    });
                };

                $scope.searchSelected = function (selectedItem) {
                    // this is needed if selected seed comes from a planning the properties of the planning will be applied.
                    // details in function applySeedSuggestionValues
                    $scope.currentSelectedSeed = selectedItem;

                    if (selectedItem.year) {
                        let selectedItemClone = _.clone(selectedItem);
                        selectedItemClone.id = selectedItem.id.substring(0, selectedItem.id.length - 6);

                        $scope.addToList(objectType, type, list, null)(selectedItemClone);
                    } else {
                        $scope.addToList(objectType, type, list, null)(selectedItem);
                    }
                };

                function getYear() {
                    return $scope.details.startDate
                        ? new Date($scope.details.startDate).getFullYear()
                        : new Date().getFullYear();
                }
            }
        ]
    };
}
